export const TYPES = {
    GET_USER_DATA : "GET_USER_DATA",
    ON_LOADING_SCREEN : "ON_LOADING_SCREEN",
    GET_USER_DATA_FAILED: "GET_USER_DATA_FAILED",
    UNAUTHORIZED : "UNAUTHORIZED",
    IS_SUPER_ADMIN : "IS_SUPER_ADMIN"
}
